exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-confirm-dialog {\n  background-color: #039be5;\n  color: #ffffff !important;\n  border-color: #039be5;\n}\n\nbutton{\n  font-size: 22px;\n  border-radius: 5px;\n  margin: 5px;\n}\n\n.cancel-button{\n  background-color: #cccccc;\n  border-color: #cccccc;\n  color: #000000;\n}\n.confirm-dialog-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  gap: 2rem;\n  min-height: 12rem;\n  padding: 2rem;\n}\n\n.message-dialog {\n  font-size: 22px;\n  color: #000000 !important;\n}\n\n.buttons-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  gap: 1rem;\n  height: auto;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/finance/confirm-dialog/confirm-dialog.component.css
// module id = 1954
// module chunks = 0